<template>
    <div>
        <div v-bind:id="'dt-wrapper-' + dtId"></div>
    </div>
</template>

<script>
    window.jQuery = $;
    require('datatables.net-bs');

    import Vue from 'vue'
    import DataTableInfoBox from './DataTableInfoBox.vue';

    var InfoComponent = Vue.extend(DataTableInfoBox);

    export default{
        name: 'DataTable',
        props: {
            dtId: {
                default: 'default',
                type: String
            },
            rowId: {
                type: String,
                default: 'DT_RowId',
            },
            columns: {},
            columnDefs: {
                type: Array,
                default: ()=> {return [
                    { "orderable": false, "targets": 'no-sort' }
                ]},
            },
            pageLength: {
                default: 50
            },
            options:{
                type: Object,
                default: ()=> {return {}},
            },
            dataUrl: {},
            lengthHandle: {},
            search: {},
            refresh: {},
            refreshViewWithPreservePaging: {},
            myAjax: {},
            onClickRow: {},
            info: {},
            onClickElement: {},
            onClickElementEvent: {},
            onPageChange: null,
            paging: {
                default: true
            },
            sort: {
                default: false
            },
            order: {
                default: ()=> {return [0,'asc']},
                type: Array,
            },
            searchValue: '',
        },
       // props: ['dt-id','columns', 'page-length', 'data-url', 'params', 'lengthHandle','search', "refresh", "response-callback", "my-ajax", "on-click-row", "info", "on-click-element", "on-click-element-event"],
        data() {
            return {
                forceID: null,
                instance: null,
                interval: null,
                tableId: null,
            }
        },
        mounted: function()
        {
            this.$root.$on('data-table:makeScrollableTable', this.makeScrollableTable);
        },
        methods: {
            init: function()
            {
                const v = this;
                this.tableId = 'datagrid-' + this.dtId;

                let options={
                    language: {
                        "processing": this.$translate.text("Processing")+'...',
                        "search": this.$translate.text("Search")+':',
                        "lengthMenu": this.$translate.text("Show _MENU_ position"),
                        "info": this.$translate.text("Position _START_ - _END_ of _MAX_"),
                        "infoEmpty": this.$translate.text("Position 0 of 0 available"),
                        "infoFiltered": "",
                        "infoPostFix": "",
                        "loadingRecords": this.$translate.text("Loading")+'...',
                        "zeroRecords": this.$translate.text("Records not found"),
                        "emptyTable": this.$translate.text('Not found'),
                        "paginate": {
                            "first": this.$translate.text("First"),
                            "previous": this.$translate.text("Previous"),
                            "next": this.$translate.text("Next"),
                            "last": this.$translate.text("Last")
                        },
                        "aria": {
                            "sortAscending": ': ' + this.$translate.text("active to asc sort column"),
                            "sortDescending": ': '+ this.$translate.text("active to desc sort column")
                        }
                    },
                    autoWidth: true,
                    // searching: false,
                    lengthMenu: [10, 50, 100, 250, 500],
                    processing: true,
                    serverSide: true,
                    columnDefs: [
                        { "orderable": false, "targets": 'no-sort' }
                    ],
                    order: v.order,
                    search: {
                        search: this.searchValue
                    }
                };
                for(let option in options){
                    if(v.options.hasOwnProperty(option)){
                        continue;
                    }
                    v.options[option]=options[option];
                }

                if (this.instance !== null) {
                    this.instance.destroy();
                }

                v.options.columns = v.columns;
                v.options.columnDefs = v.columnDefs;
                v.options.rowId = v.rowId;
                v.options.ajax = v.myAjax;
                v.options.searching = (v.searchValue || v.search) ? true : false;

                if (v.pageLength) {
                    v.options.iDisplayLength = v.pageLength;
                }

                v.options.paging = v.paging ? true : false;
                v.options.sort = v.sort ? true : false;

                let tableHeaders = '';

                for (let i in v.options.columns) {
                    if (v.options.columns.hasOwnProperty(i)) {
                        let columnName = v.options.columns[i].name;
                        let i18nParams = v.options.columns[i].i18nParams;
                        tableHeaders += '<th id="header-'+this.dtId+'-'+i+'">' + this.$trans(columnName, i18nParams) + '</th>';
                    }
                }

                $('#dt-wrapper-'+this.dtId).empty().append('<table id="' + this.tableId + '" class="table" cellspacing="0" style="width:100%;">' + '<thead><tr>' + tableHeaders + '</tr></thead></table>');

                let datagrid = $('#' + this.tableId);

                v.instance = datagrid.DataTable(this.options);

                /*****/

                if (v.info)
                {
                    let infoBox = $('<div id="info-box-container-'+this.dtId+'"></div>');

                    $(this.$el.querySelector('.dataTables_scroll')).append(infoBox);

                    new InfoComponent({data: v.info}).$mount(infoBox[0]);
                }

                /*****/

                if(this.onClickRow){
                    datagrid.find('tbody').on('click', 'tr', (e) => {
                        e.preventDefault();
                        let a = $(e.target);
                        let tr = a.closest('tr');
                        let row = v.instance.row(tr);
                        let id = tr.attr('id');
                        v.onClickRow(id,row,e);
                    });
                }

                if (typeof this.onPageChange === 'function') {
                    datagrid.on('page.dt', this.onPageChange);
                }

                if (this.onClickElement, this.onClickElementEvent) {
                    datagrid.find('tbody').on('click', this.onClickElement, (e) => {
                        e.preventDefault();
                        let target = $(e.target);
                        let tr = target.closest('tr');
                        let row = v.instance.row(tr);
                        let id = tr.attr('id');
                        let data = v.instance.row(tr).data();
                        v.onClickElementEvent(id, row, e, data);
                    });
                }

                if (this.lengthHandle)
                {
                    let dtLength = $('#datagrid-'+this.dtId+'_length'), dtBox = $(this.lengthHandle);
                    let dtLengthParams = dtLength.find('select');

                    if (v.dtLength != null) {
                        dtLengthParams.val(v.dtLength);
                        dtLengthParams.trigger('change');
                    }

                    dtBox.html( dtLengthParams.removeClass('input-sm') );
                    dtLength.remove();

                    $('select[name="datagrid_length"]').change(function(){
                        v.dtLength = $(this).val();
                    });
                }
                else{
                    $('#datagrid-'+this.dtId+'_length').remove();
                }

                let dtSearch = $('#datagrid-'+this.dtId+'_filter');
                let dtSearchInput = dtSearch.find('input[type="search"]');

                if (this.search)
                {
                    this.options.searching = true;
                    $(this.search.handle).empty();

                    if (!$(this.search.handle).has('input').length)
                    {
                        dtSearchInput.addClass('form-control');
                        dtSearchInput.removeClass('input-sm');

                        if (this.search.placeholder !== undefined) {
                            dtSearchInput.attr('placeholder', this.search.placeholder);
                        }
                        else {
                            dtSearchInput.attr('placeholder', 'Szukaj');
                        }

                        $(this.search.handle).append(dtSearchInput);
                    }
                    dtSearch.remove();
                }
            },
            makeScrollableTable: function () {
                let $table = $('#' + this.tableId);
                let $bodyCells = $table.find('tbody tr:first').children();
                let $headCells = $table.find('thead tr:first').children();
                let headColWidth = 0;
                let bodyColWidth = 0;
                let tbodyHeight = screen.height - 330;

                $table.find('thead').css("display", "");
                $table.find('tbody').css("display", "");
                $table.find('tbody').css("height", "");
                $table.find('tbody').css("overflow-y", "");
                $table.find('tbody').css("overflow-x", "");

                headColWidth = $headCells.map(function () {
                    return $(this).outerWidth();
                }).get();
                bodyColWidth = $bodyCells.map(function () {
                    return $(this).outerWidth();
                }).get();

                $table.find('thead tr').children().each(function (i, v) {
                    $(v).css("width", headColWidth[i] + "px");
                    $(v).css("min-width", headColWidth[i] + "px");
                    $(v).css("max-width", headColWidth[i] + "px");
                });
                $table.find('tbody tr').children().each(function (i, v) {
                    $(v).css("width", bodyColWidth[i] + "px");
                    $(v).css("min-width", bodyColWidth[i] + "px");
                    $(v).css("max-width", bodyColWidth[i] + "px");
                });

                $table.find('thead').css("display", "block");
                $table.find('tbody').css("display", "block");

                $table.find('tbody').css("max-height", tbodyHeight + "px");
                $table.find('tbody').css("overflow-y", "auto");
                $table.find('tbody').css("overflow-x", "hidden");
            },
        },
        watch: {
            refresh: {
                handler: function(newData, oldData) {
                    if (this.instance) {
                        if (!this.searchValue) {
                            this.instance.search(this.searchValue);
                        }
                        this.instance.ajax.reload();
                    } else {
                        this.init();
                    }
                }
            },
            refreshViewWithPreservePaging: {
                handler: function(newData, oldData) {
                    if (!this.instance) {
                        return;
                    }

                    this.instance.ajax.reload(null, false);
                }
            },
            searchValue: {
                handler: function(newData, oldData) {
                    let _this = this;
                    if (this.instance)
                    {
                        clearInterval(this.interval);

                        this.interval = setTimeout(() => {
                            _this.instance.search(newData);
                            _this.instance.ajax.reload();
                        }, 2000);
                    }
                }
            },
            pageLength: {
                handler: function(newData, oldData) {
                    if (this.instance && newData)
                    {
                        this.instance.page.len(newData);
                        this.instance.ajax.reload();
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    #help-box {
        position:absolute;
        width:350px;
        height:100%;
        background-color:green;
        right:0;
        z-index:1
    }

    table.dataTable thead .no-sort::after { display: none!important; }
    table.dataTable thead .no-sort { pointer-events: none!important; cursor: default!important; }

    table.dataTable td,
    table.dataTable th {
        -webkit-box-sizing: border-box!important;
        box-sizing: border-box !important;
    }

    .dataTables_filter {

    }

    .dataTables_wrapper {
      overflow-x: auto !important;
    }

    .dataTables_wrapper .row {
      margin-right: 0;
    }
</style>



// WEBPACK FOOTER //
// DataTable.vue?2d83e9d3